import { useTranslation } from 'react-i18next'

import { connectRequestDocFlows, getRequestProfileBase } from '../../../../api'
import { DocFlowRequestLinksField } from '../../../../constants/docFlow'
import { useNotification } from '../../../../hooks'
import { getItemsIds } from '../../../../utils/common'
import {
  getDocFlowRequestLinksErrorNotification,
  getRequestDocFlowsPayload,
} from '../../../../utils/docFlow'
import { DocFlowSelectModal } from '../../../DocFlowSelectModal'

// The ids of the already linked doc flows come only with the request detail,
// so the pop-up opens once it is loaded.
export function useRequestConnectDocFlowsModalOpener({
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleConnectDocFlows({ id, selected }) {
    return connectRequestDocFlows({
      data: getRequestDocFlowsPayload(getItemsIds(selected)),
      id,
    })
      .then(() => {
        onCloseModal()
        onReload()

        handleAddSuccessNotification({
          title: t('Notification.RequestTitleConnectDocFlowsKey', {
            count: selected.length,
          }),
        })
      })
      .catch(error => {
        handleAddErrorNotification(
          getDocFlowRequestLinksErrorNotification({ error, t })
        )
      })
  }

  async function handleOpenConnectDocFlows(requestId) {
    return getRequestProfileBase({ id: requestId })
      .then(({ data }) => {
        onSetModal(
          <DocFlowSelectModal
            showLimitNotification
            entityId={requestId}
            excludeIds={data[DocFlowRequestLinksField.RequestDocFlowIds]}
            onAttach={handleConnectDocFlows}
            onClose={onCloseModal}
          />
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  return { handleOpenConnectDocFlows }
}
